import React from "react";
import {ABreadcrumb, ACol, AContainer, ARow} from "@cisco-sbg-ui/magna-react";
import {appConfig} from "config/defaultConfig";
import {t} from "i18next";
import {Link} from "react-router-dom";
import SavedInvestigationsPanel from "features/investigate/SavedInvestigationsPanel";
import {DEFAULT_RESULTS_PER_PAGE} from "models/options";

const {ROUTES} = appConfig.APP;

const SavedInvestigation = () => {
  return (
    <AContainer fluid>
      <ARow>
        <ACol xs="12">
          <div className="ma-4">
            <ABreadcrumb
              className="pa-0"
              items={[
                {
                  component: Link,
                  content: t("investigate.title"),
                  contentProps: {
                    to: ROUTES.INVESTIGATE
                  }
                }
              ]}
              data-testid={"SavedInvestigations-Breadcrumb"}
            />
            <h1>{t("investigate.savedInvestigations.title")}</h1>
          </div>
          <SavedInvestigationsPanel
            resultsPerPage={DEFAULT_RESULTS_PER_PAGE}
            showTitle={false}
          />
        </ACol>
      </ARow>
    </AContainer>
  );
};

export default SavedInvestigation;
